import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

const APP_NAME = 'E-Check';

@Injectable({ providedIn: 'root' })
export class TranslateTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly translate = inject(TranslateService);
  private lastTitleKey?: string;

  constructor() {
    super();
    this.translate.onLangChange.subscribe(() => {
      this.setPageTitle(this.lastTitleKey);
    });
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.lastTitleKey = this.buildTitle(snapshot);
    this.setPageTitle(this.lastTitleKey);
  }

  private setPageTitle(key: string | undefined): void {
    if (!key) {
      this.title.setTitle(APP_NAME);
      return;
    }
    this.translate.get(key).subscribe((translated) => {
      this.title.setTitle(`${translated} | ${APP_NAME}`);
    });
  }
}
